import {
  fileTypeByUrl,
  getFileFormat,
} from '@/components/file-thumbnail/utils';

export const isImageFile = (fileName: string): boolean => {
  const format = getFileFormat(fileTypeByUrl(fileName));

  return format === 'image';
};

export const getFileIconSrc = (fileName: string): string => {
  const baseUrl = (icon: string) => `/icons/files/Type=${icon}`;
  switch (getFileFormat(fileTypeByUrl(fileName))) {
    case 'txt':
      return baseUrl('txt');
    case 'hwp':
      return baseUrl('hwp');
    case 'zip':
      return baseUrl('zip');
    case 'audio':
      return baseUrl('wav (Default)');
    case 'video':
      return baseUrl('video');
    case 'word':
      return baseUrl('docx');
    case 'excel':
      return baseUrl('xlsx');
    case 'powerpoint':
      return baseUrl('ppt');
    case 'pdf':
      return baseUrl('pdf');
    case 'image':
      return baseUrl('image');
    default:
      return baseUrl('default');
  }
};

export const getFileNameAndExt = (filename: string) => {
  const dotIndex = filename.lastIndexOf('.');
  if (dotIndex === -1) return { name: filename, ext: '' };

  return {
    name: filename.slice(0, dotIndex),
    ext: filename.slice(dotIndex),
  };
};

const IMG_EXTS = new Set(['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp']);

export const getExtensionIcon = (ext: string): string => {
  const lowerExt = ext.toLowerCase();
  if (IMG_EXTS.has(lowerExt)) return '/icons/approval/attachment-img.svg';
  if (lowerExt === 'doc' || lowerExt === 'docx')
    return '/icons/approval/attachment-docx.svg';
  if (lowerExt === 'pdf') return '/icons/approval/attachment-pdf.svg';
  if (lowerExt === 'xls' || lowerExt === 'xlsx' || lowerExt === 'csv')
    return '/icons/approval/attachment-xlsx.svg';
  if (lowerExt === 'ppt' || lowerExt === 'pptx')
    return '/icons/approval/attachment-ppt.svg';
  if (lowerExt === 'hwp' || lowerExt === 'hwpx')
    return '/icons/approval/attachment-hwp.svg';
  if (lowerExt === 'txt') return '/icons/approval/attachment-txt.svg';
  if (
    lowerExt === 'zip' ||
    lowerExt === 'rar' ||
    lowerExt === '7z' ||
    lowerExt === 'tar' ||
    lowerExt === 'gz'
  )
    return '/icons/approval/attachment-zip.svg';
  return '/icons/approval/attachment-file.svg';
};
